<template>
  <div class="tw-py-2.5 tw-px-5">
    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <WdsStack direction-row gap-sm justify-space-between>
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <WdsStack direction-row justify-start>
        <div class="tw-mr-2 tw-font-normal tw-text-lg tw-text-gray-900">
          {{ name }}
        </div>
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <WdsTooltip v-if="isHired || isCancelled || isRejected" :text="handleTooltipText()" top>
          <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
          <WdsLabel
            subtle
            :label="handleLabelText()"
            :primary="isHired"
            :error="isRejected"
            :warning="isCancelled"
          />
        </WdsTooltip>
      </WdsStack>
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <WdsButtonGhost primary @click="scrollToOffer">
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <WdsButtonText>{{ $t('View') }}</WdsButtonText>
      </WdsButtonGhost>
    </WdsStack>
  </div>
</template>

<script>
import {
  WdsStack,
  WdsLabel,
  WdsButtonGhost,
  WdsButtonText,
  WdsTooltip,
} from '@worksome/wds-components'

export default {
  name: 'DialogCandidateItem',
  components: [WdsStack, WdsLabel, WdsButtonGhost, WdsTooltip, WdsButtonText],
  props: {
    name: {
      type: String,
      required: true,
    },
    isHired: {
      type: Boolean,
      default: false,
    },
    isRejected: {
      type: Boolean,
      default: false,
    },
    isCancelled: {
      type: Boolean,
      default: false,
    },
    offerId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    handleLabelText() {
      if (this.isHired) {
        return $t('Hired')
      }
      if (this.isRejected) {
        return $t('Rejected')
      }

      return $t('Cancelled')
    },
    handleTooltipText() {
      if (this.isHired) {
        return `${this.name} ${$t('has been hired')}`
      }
      if (this.isRejected) {
        return `${this.name} ${$t('has been rejected')}`
      }

      return `${this.name} ${$t('has cancelled the offer')}`
    },
    scrollToOffer() {
      const elementId = `supplier-offer-${this.offerId}`
      const element = document.getElementById(elementId)

      element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' })
      element.classList.add('highlight-offer')

      setTimeout(() => {
        element.classList.remove('highlight-offer')
      }, 3000)
    },
  },
}
</script>

<style lang="scss">
.highlight-offer {
  @apply tw-border-indigo-400;
  box-shadow: 0 0 0 2px #e8e2ff;
}
</style>
